var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoParties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property Detail - Pricng detail closed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 3741,
    transform: "translate(-541.75 -1850.75)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA1\xD0\xBB\xD0\xBE\xD0\xB9_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7042 7.47927C11.5479 7.41046 11.3689 7.48695 11.3031 7.64959C10.6081 9.37155 9.11732 10.5456 8.32861 10.7968C8.32485 10.7981 8.3216 10.8002 8.31801 10.8015C8.30809 10.8051 8.29869 10.8094 8.28929 10.814C8.28005 10.8183 8.27099 10.8229 8.26227 10.8283C8.25441 10.8331 8.24688 10.839 8.23936 10.8446C8.23013 10.8515 8.22124 10.8587 8.21286 10.8665C8.21029 10.869 8.20722 10.8707 8.20465 10.8733L7.51767 11.5714C7.39645 11.6946 7.39371 11.897 7.51151 12.0238C7.54349 12.0579 7.5811 12.0826 7.62111 12.0986C7.56708 12.1828 7.50416 12.2632 7.43731 12.3791C7.22957 12.7388 6.99414 13.1465 6.99414 13.9266C6.99414 14.709 7.23077 15.1065 7.43936 15.457C7.62863 15.7749 7.79209 16.0494 7.79209 16.6492C7.79209 16.8258 7.92904 16.9691 8.09813 16.9691C8.26723 16.9691 8.40418 16.8258 8.40418 16.6492C8.40418 15.8668 8.16755 15.4693 7.95896 15.1188C7.76969 14.8009 7.60624 14.5264 7.60624 13.9266C7.60624 13.3247 7.77071 13.0396 7.96135 12.7097C8.06052 12.5381 8.16601 12.3519 8.24979 12.1204H8.81863C8.98755 12.1204 9.12468 11.9771 9.12468 11.8005C9.12468 11.624 8.98755 11.4806 8.81863 11.4806H8.48488L8.58354 11.3802C9.52117 11.0428 11.108 9.77868 11.8673 7.89783C11.9328 7.73555 11.8598 7.54789 11.7042 7.47927Z",
    fill: "#01152E",
    stroke: "#01152E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.1604 0.343694C16.0409 0.218769 15.8472 0.218769 15.7277 0.343694L12.1037 4.13184C11.5502 2.12964 9.93585 0.724904 8.09888 0.724904C5.77753 0.724904 3.88876 2.93102 3.88876 5.64256C3.88876 8.07298 5.34872 9.7197 6.10102 10.4063L0.339634 16.4285C0.220122 16.5534 0.220122 16.7559 0.339634 16.8808C0.399305 16.9434 0.477783 16.9747 0.55609 16.9747C0.634397 16.9747 0.712704 16.9434 0.772546 16.881L16.1604 0.796213C16.2799 0.671288 16.2799 0.468798 16.1604 0.343694ZM6.53496 9.95257C5.86559 9.35154 4.50085 7.85422 4.50085 5.64238C4.50085 3.28364 6.11487 1.36454 8.09871 1.36454C9.76436 1.36454 11.219 2.7439 11.5986 4.65942L6.53496 9.95257Z",
    fill: "#01152E",
    stroke: "#01152E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.67279 2.3648C8.51566 2.2974 8.3375 2.37552 8.27321 2.53874C8.20876 2.70213 8.28313 2.88912 8.4394 2.95652C9.1098 3.24559 9.66582 3.81872 10.005 4.57044C10.0574 4.6861 10.1673 4.75385 10.282 4.75385C10.3258 4.75385 10.3704 4.74402 10.4125 4.7231C10.5655 4.64766 10.6308 4.45692 10.5587 4.2971C10.1541 3.40094 9.48424 2.71465 8.67279 2.3648Z",
    fill: "#01152E",
    stroke: "#01152E",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoParties);
export default __webpack_public_path__ + "static/media/no-parties.62fd9aae28a073c5348e21943f87b3bd.svg";
export { ForwardRef as ReactComponent };